import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

function AssessmentTab({ selectedTab, onTabChange }) {
  const [key, setKey] = useState(selectedTab || "assessments");

  // keep local key in sync if parent's persisted tab changes externally
  useEffect(() => {
    if (selectedTab && selectedTab !== key) {
      setKey(selectedTab);
    }
  }, [selectedTab]);

  const handleTabChange = (k) => {
    setKey(k);
    onTabChange(k);
  };

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={handleTabChange}
      className="mb-3 custom-tabs"
    >
      <Tab eventKey="assessments" title="Benchmark Assessments"></Tab>
      <Tab eventKey="progressMonitoring" title="Progress Monitoring"></Tab>
    </Tabs>
  );
}

export default AssessmentTab;
